import {GlossaryTerm} from "../../actions/api";
import {SetFocusedTerm} from "./Glossary";
import { useState, useEffect } from "react";
import React from "react";
import { AutoComplete } from "antd";
import styles from '../../components/AppSearch/Search.module.scss';
import Search from "antd/lib/input/Search";

const toOption = (groupItem: GlossaryTerm, searchText: string) => {
    const title = groupItem.title
    const highlightStart = title.toLowerCase().indexOf(searchText.toLowerCase())
    const highlightEnd = highlightStart + searchText.length
    return {
        key: groupItem.id,
        value: title,
        label: <div>
            <p className={styles.glossarySearchTitle}>
                {title.slice(0, highlightStart)}
                <span className={styles.glossarySearchHighlight}>{title.slice(highlightStart, highlightEnd)}</span>
                {title.slice(highlightEnd, title.length)}
            </p>
        </div>
    }
}

const determineDataset = (currentDataset: number | undefined, selectedTitle: string, glossary: GlossaryTerm[]) => {
    if (currentDataset === undefined) {
        return undefined
    }

    const searchTitle = selectedTitle.toLowerCase()

    const term = glossary.find(term => term.title.toLowerCase() === searchTitle.toLowerCase())

    if (term === undefined) {
        return currentDataset
    }

    return term.datasets.findIndex(dataset => dataset.id === currentDataset) > -1 ? currentDataset : undefined
}

function getGlossaryByDataset(selectedDataset: number | undefined, glossary: GlossaryTerm[]) {
    return selectedDataset === undefined ? glossary
        : glossary.filter(term => term.datasets.map(dataset => dataset.id).includes(selectedDataset));
}

export const GlossarySearch = ({glossary, setFocusedTerm, selectedDataset, setSelectedDataset}: {
    glossary: GlossaryTerm[],
    setFocusedTerm: SetFocusedTerm,
    selectedDataset: number | undefined,
    setSelectedDataset: (dataset: number | undefined) => void
}) => {
    const [value, setValue] = useState('');
    const [options, setOptions] = useState<GlossaryTerm[]>([])

    useEffect(() => {
        setValue('')
        setOptions(getGlossaryByDataset(selectedDataset, glossary))
    }, [glossary, selectedDataset])



    const onSearch = (searchText: string) => {
        setValue(searchText)
        const glossaryByDataset = getGlossaryByDataset(selectedDataset, glossary)
        const result = searchText.trim() === '' ? glossaryByDataset
            : glossaryByDataset.filter(option => option.title.toLowerCase().includes(searchText.toLowerCase()))
        setOptions(result);
    };
    return (
        <div className={`${styles.container} ${styles.fixedTopRight}`}>
            <AutoComplete
                className={styles.search}
                popupClassName={styles.glossarySearchDropDown}
                value={value}
                onSearch={onSearch}
                onSelect={(title) => {
                    setSelectedDataset(determineDataset(selectedDataset, title, glossary))
                    setFocusedTerm({ title, searchTitle: title })
                }}
                options={options
                    .slice()
                    .sort((a, b) => a.title.localeCompare(b.title))
                    .map(term => toOption(term, value))}
            >
                <Search
                    placeholder="Search the glossary..."
                    allowClear
                    className={styles.searchInput} // input-specific styles (optional)
                />
            </AutoComplete>
        </div>
    );
}